export function useConstructAriaLabel() {
  const constructAriaLabel = (
    supplementalQuestionPrompt?: string,
    secondaryText?: string,
    label?: string,
    optional = false,
    maxCharacterLimit?: number
  ) => {
    const supplementalQuestionPromptSubstring = supplementalQuestionPrompt
      ? `${supplementalQuestionPrompt} `
      : "";
    const secondaryTextSubstring = secondaryText ? `${secondaryText} ` : "";
    const labelSubstring = label ? `${label} ` : "";
    const optionalSubstring = optional ? `(Optional) ` : "";
    const maxCharacterLimitSubString = maxCharacterLimit
      ? `Max ${maxCharacterLimit} characters. `
      : "";

    return (
      supplementalQuestionPromptSubstring +
      optionalSubstring +
      secondaryTextSubstring +
      labelSubstring +
      maxCharacterLimitSubString
    );
  };

  return {
    constructAriaLabel,
  };
}
